import { db } from '../../firebase';
import {
    doc,
    setDoc,
    getDoc,
    collection,
    getDocs,
    query,
    where
} from 'firebase/firestore';

const TARGETS_COLLECTION = 'admin_settings';
const TARGET_DOC_ID = 'service_targets';

export const saveServiceTargets = async (targets) => {
    try {
        const docRef = doc(db, TARGETS_COLLECTION, TARGET_DOC_ID);
        await setDoc(docRef, {
            targets,
            updatedAt: new Date().toISOString()
        }, { merge: true });
        return true;
    } catch (error) {
        console.error("Error saving targets:", error);
        throw error;
    }
};

export const getServiceTargets = async () => {
    try {
        const docRef = doc(db, TARGETS_COLLECTION, TARGET_DOC_ID);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
            return docSnap.data().targets || {};
        }

        // Return defaults if none set
        return {
            'Financial Diagnosis': 100,
            'Roadmap': 50,
            'Hands-on': 30,
            'Coaching Training': 20
        };
    } catch (error) {
        console.error("Error getting targets:", error);
        throw error;
    }
};
